
import {PromiseErrorHandler} from '../utils/Error';
import router from '../router';
import {Browser} from "../h5_src/utils/classes/browser/Browser";

export class Navigator {

    public static redirectWeixinAuth(silent = false) {
        let scheme = Browser.autoScheme();
        let host = `${scheme}://wx.yooz.cn`;
        let weixinAuthUrl = `${host}/server/wxapi/112/open_id/direct/1`;
        if (silent) { weixinAuthUrl += '/silent/1'; }   // 静默授权
        this.openLink(weixinAuthUrl);
    }

    // 用 location.replace 方法打开外部 url
    // 这个 url 在 router 集合之外，如果用 redirect 方法会返回 404
    public static openLink(url) {
        return location.replace(url);
    }

    public static push(url) {
        return window.location = url;
    }

    public static replace(location, onComplete?, onAbort?) {
        return  router.replace(location, onComplete, onAbort);
    }

    public static redirectByName(path, param?:object) {

        router.replace(path).catch(PromiseErrorHandler);
        // router.replace(path);

    }

    public static redirect(path:string, query?) {
        let param = {
            path: path,
            query: query
        };
        router.replace(param).catch(PromiseErrorHandler);
    }

    public static loginSuccess(path?:string) {

        let kind = 'default';

        if (!path) {
            path    = '/';
        } else {
            kind    = 'custom';
        }

        // console.log(['login-succ-param', router.currentRoute]);

        if (router.currentRoute.query.redirect) {
            path    = router.currentRoute.query.redirect + '';
            kind    = 'redirect';
        }

        let param = {
            path: path,
            query: {from:'login', kind:kind}
        };

        router.replace(param).catch(PromiseErrorHandler);

    }

}
